var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148599",
    "data-name": "Rectangle 148599",
    width: 24,
    height: 24,
    transform: "translate(291 279)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-291 -279)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "garbage",
    transform: "translate(294.414 281.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11729",
    "data-name": "Group 11729",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8868",
    "data-name": "Path 8868",
    d: "M43.537,2.779H39.52V2.124A2.126,2.126,0,0,0,37.4,0H33.577a2.126,2.126,0,0,0-2.124,2.124v.655H27.436a.536.536,0,0,0,0,1.072H28.4V16.442a2.87,2.87,0,0,0,2.866,2.866H39.7a2.87,2.87,0,0,0,2.866-2.866V3.851h.969a.536.536,0,0,0,0-1.072ZM32.525,2.124a1.054,1.054,0,0,1,1.052-1.052H37.4a1.054,1.054,0,0,1,1.052,1.052v.655H32.525ZM41.5,16.442A1.8,1.8,0,0,1,39.7,18.237H31.271a1.8,1.8,0,0,1-1.794-1.794V3.851H41.5V16.442Z",
    transform: "translate(-26.9)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8869",
    "data-name": "Path 8869",
    d: "M230.236,155.943a.534.534,0,0,0,.536-.536v-9.472a.536.536,0,0,0-1.072,0V155.4A.537.537,0,0,0,230.236,155.943Z",
    transform: "translate(-221.65 -139.628)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8870",
    "data-name": "Path 8870",
    d: "M142.136,169.564a.534.534,0,0,0,.536-.536v-8.293a.536.536,0,1,0-1.072,0v8.293A.536.536,0,0,0,142.136,169.564Z",
    transform: "translate(-137.047 -153.841)",
    fill: "#0c0c0b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8871",
    "data-name": "Path 8871",
    d: "M318.336,169.564a.534.534,0,0,0,.536-.536v-8.293a.536.536,0,1,0-1.072,0v8.293A.534.534,0,0,0,318.336,169.564Z",
    transform: "translate(-306.252 -153.841)",
    fill: "#0c0c0b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c9e8c9de.svg";
export { ForwardRef as ReactComponent };